import { SettingsContext } from 'context/context';
import { useContext } from 'react';

function PCList({list, label, className}) {
  const { state } = useContext(SettingsContext);

  const filterList = (list) => {
    let filteredList = list;
    if (!state.displayEquipment) {
      filteredList = filteredList.filter((ability) => !ability.addon)
    }

    return <span dangerouslySetInnerHTML={{__html: filteredList.map((item) => item.name).join(', ')}}></span>
  }

  return (
    <div className={`pc-list ${className}`}>
      <strong>{label}:&nbsp;</strong>
      { filterList(list) }
    </div>
  );
}

export default PCList;
